import React, {  } from "react"
import { useTranslation } from "react-i18next"

import leftArrow from "../../assets/common/prvsArrow.svg"
import { ErrorField } from "../../components/Common/Form/Error"
import { InputBox } from "../../components/Common/Form/InputBox/InputBox"

const RequestNewPassword=({
    formData,
    errors,
    onInputChange,
    setActivePage,
    onSubmit
})=>{
    const { t } = useTranslation()

    return <>
        <div className="flex bg-white border-solid border rounded-lg border-gray py-6 px-4 flex-col w-[456px]">
            <div className="flex pb-1">
                <span className="pt-1">
                    <button onClick={ ()=>setActivePage("logInPage") }>
                        <img src={ leftArrow } alt="leftarrow" />
                    </button>              
                </span>
                <span className="pl-1 text-2xl font-bold  text-primary-50">
                    { t ("login.requestNewPassword") }
                </span>
            </div>
            <span className="text-secondary-200">
                { t ("login.requestPasswordDesc") }
            </span>
            <div className="flex py-4">
                <div className="w-full relative">
                    <InputBox
                        label={ t("login.email") }
                        id="resetemail"
                        type="text"
                        name="email"
                        value={ formData?.email }
                        errors={ errors }
                        defaultValue={ "" }
                        isRequired={ true }
                        textHideRequired={ false }
                        maxLength="50"
                        isComponentLabelValidation={ false }
                        onChangeHandler={ (e) => onInputChange(e) }
                    />
                    <ErrorField name={ errors?.email } />
                </div>
            </div>
            <div className="flex py-4">
                <button
                    type="button"
                    id="reqBtn"
                    onClick={ onSubmit }
                    // disabled={ permission?._write ? false : true }
                    className={ `w-full text-white border border-solid hover:border-primary-150 
 bg-primary-100 hover:bg-primary-150 border-primary-50 hover:text-primary-50 
 font-bold text-base px-6 py-3 outline-none focus:outline-1 
 focus:outline-black focus:outline-offset-2 rounded-full 
 disabled:bg-primary-300 disabled:text-secondary-50 disabled:border-0` }
                >
                    { t("common.submit")  }
                </button>
            </div>
        </div>
    </>
}


export default RequestNewPassword
